import { render, staticRenderFns } from "./SigningDocument.handler.vue?vue&type=template&id=49609516&"
import script from "./SigningDocument.handler.vue?vue&type=script&lang=ts&"
export * from "./SigningDocument.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports